
export interface BucketFormData {
  name: string;
  budget: string;
  customName: string;
  allocationPercentage: number;
}

export const createInitialBucketFormData = (): BucketFormData => ({
  name: "",
  budget: "",
  customName: "",
  allocationPercentage: 0
});
